import http from '@/api/common'

export default {
  getJatoVehicleYears() {
    return http.get('ragrating/JatoVehicleYears')
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/jato.js